// angular
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreService } from '../../core/core.service';

// others
import { MePackageService } from './me-package.service';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../app.service';

@Component({
    selector: 'me-package',
    templateUrl: './me-package.component.html',
    styleUrls: ['./me-package.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [MePackageService]
})

export class MePackageComponent implements OnInit {
    url= 'packages/';
    data = {};
    price;
    salePrice;
    formatPrice = '€59.50';
    formatSalePrice = '€100';

    @Input() type;
    @Input() bexioData = {};
    @Input() header;

    constructor(
        public mePackageService: MePackageService,
        public route : ActivatedRoute,
        public router: Router,
        public coreService : CoreService,
        public translate : TranslateService,
        public appService: AppService
    ) {
    }

    ngOnInit() {
        this.getContent();
        this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });
    }

    ngOnChanges(changes) {
        if (changes['bexioData']) {
            if (changes['bexioData']['currentValue']) {
                this.price = parseFloat(changes['bexioData']['currentValue']['sale_price']);
                this.formatCurrency();
            }
        }
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url + this.type).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            if (this.data['discount'] && this.data['discount'] != 0) {
                this.salePrice = (parseFloat(this.price) * 100) / parseFloat(this.data['discount']);
            }
            this.formatCurrency();
        });
    }

    choosePackage() {
        this.router.navigate(['me/payment'],{
            queryParams: {
                articleType: this.bexioData['article_id']
            }
        })
    }
    
    formatCurrency() {
        this.formatPrice = this.coreService.formatCurrency(this.price, this.bexioData['currency_code'] ?? 'EUR');
        this.formatSalePrice = this.coreService.formatCurrency(this.salePrice, this.bexioData['currency_code'] ?? 'EUR');
    }
}
